import React from "react";
import styles from "./style.module.css";
import Slider from "rc-slider";
import { debounce } from "throttle-debounce";
const createSliderWithTooltip = Slider.createSliderWithTooltip;
const Range = createSliderWithTooltip(Slider.Range);
const DateSelector = ({ dateIndices, updateDateIndices, dateArray, labelLookup, isDisabled, tipPlacement = "top" }) => {
    const sliderHeight = 20;
    const throttledUpdateDateIndices = debounce(50, updateDateIndices);
    return (React.createElement("div", { className: styles.dateSelectorWrapper },
        React.createElement(Range, { pushable: 0, min: 0, max: dateArray.length - 1, step: 1, disabled: isDisabled, onChange: (v) => {
                if (v?.length) {
                    const newRange = v.slice(1, 5);
                    throttledUpdateDateIndices(newRange);
                }
            }, value: [0, ...dateIndices, dateArray.length - 1], railStyle: { backgroundColor: "#C8CAD4", height: 5 }, trackStyle: [
                { backgroundColor: "#C8CAD4", height: 5, borderRadius: 0 },
                { backgroundColor: "#8884d8", height: 5, borderRadius: 0 },
                { backgroundColor: "#C8CAD4", height: 5, borderRadius: 0 },
                { backgroundColor: "#34D399", height: 5, borderRadius: 0 },
                { backgroundColor: "#C8CAD4", height: 5, borderRadius: 0 }
            ], handleStyle: [
                {
                    height: sliderHeight,
                    width: 0,
                    cursor: "default",
                    borderColor: "#FFFFFF",
                    borderWidth: 0,
                    borderRadius: 2,
                    backgroundColor: "#7E69D700",
                    marginTop: 0,
                    marginLeft: 0,
                    zIndex: -100
                },
                {
                    position: "absolute",
                    height: sliderHeight,
                    width: 4,
                    borderColor: "#FFFFFF",
                    borderWidth: 0,
                    borderRadius: 0,
                    backgroundColor: "#7E69D7",
                    marginTop: -8,
                    marginLeft: 0,
                    zIndex: 1
                },
                {
                    position: "absolute",
                    height: sliderHeight,
                    width: 4,
                    borderColor: "#FFFFFF",
                    borderWidth: 0,
                    borderRadius: 0,
                    backgroundColor: "#7E69D7",
                    marginTop: -8,
                    marginLeft: -2,
                    zIndex: 1
                },
                {
                    position: "absolute",
                    height: sliderHeight,
                    width: 4,
                    borderColor: "#FFFFFF",
                    borderWidth: 0,
                    borderRadius: 0,
                    backgroundColor: "#34D399",
                    marginTop: -8,
                    marginLeft: 2,
                    zIndex: 1
                },
                {
                    position: "absolute",
                    height: sliderHeight,
                    width: 4,
                    borderColor: "#FFFFFF",
                    borderWidth: 0,
                    borderRadius: 0,
                    backgroundColor: "#34D399",
                    marginTop: -8,
                    marginLeft: 0,
                    zIndex: 1
                },
                {
                    height: sliderHeight,
                    width: 0,
                    cursor: "default",
                    borderColor: "#FFFFFF",
                    borderWidth: 0,
                    borderRadius: 2,
                    backgroundColor: "#7E69D700",
                    marginTop: 0,
                    marginLeft: 0,
                    zIndex: -100
                }
            ], tipProps: {
                placement: tipPlacement,
                prefixCls: "rc-slider-tooltip"
            }, tipFormatter: (value) => {
                const vDate = dateArray?.[value];
                if (vDate === undefined) {
                    return null;
                }
                const vLabel = labelLookup?.[vDate] ?? vDate;
                return React.createElement("div", { className: styles.dateSelectorTooltip }, vLabel);
            } })));
};
export default DateSelector;
